var SetLanguage = {

	eng:{//English
		navigationpublic:require('./languages.eng/eng.navigation.public.js'),
                navigation:require('./languages.eng/eng.navigation.js'),
                footerpublic:require('./languages.eng/eng.footer.public.js'),
                footer:require('./languages.eng/eng.footer.js'),
                login:require('./languages.eng/eng.login.js'),
                forgotpassword:require('./languages.eng/eng.forgotpassword.js'),
                restorepassword:require('./languages.eng/eng.restorepassword.js'),
                restorepasswordmanual:require('./languages.eng/eng.restorepasswordmanual.js'),
                agencyregister:require('./languages.eng/eng.agencyregister.js'),
                agentregister:require('./languages.eng/eng.agentregister.js'),                
                page404:require('./languages.eng/eng.404.js'),
                globalhome:require('./languages.eng/eng.globalhome.js'),
                home:require('./languages.eng/eng.home.js'),
                registerbooking:require('./languages.eng/eng.registerbooking.js'),
                reservhotel:require('./languages.eng/eng.reservhotel.js'),
                trackredeem:require('./languages.eng/eng.trackredeem.js'),
                detailsfaqs:require('./languages.eng/eng.detailsfaqs.js'),
                contactmodal:require('./languages.eng/eng.contactmodal.js'),
                multimediamodal:require('./languages.eng/eng.multimediamodal.js'),
                welcomemodal:require('./languages.eng/eng.welcomemodal.js'),
                webinar:require('./languages.eng/eng.webinar.js')
                		
	},

	esp:{//español
            navigationpublic:require('./languages.esp/esp.navigation.public.js'),
                navigation:require('./languages.esp/esp.navigation.js'),
                footerpublic:require('./languages.esp/esp.footer.public.js'),
                footer:require('./languages.esp/esp.footer.js'),
                login:require('./languages.esp/esp.login.js'),
                forgotpassword:require('./languages.esp/esp.forgotpassword.js'),
                restorepassword:require('./languages.esp/esp.restorepassword.js'),
                restorepasswordmanual:require('./languages.esp/esp.restorepasswordmanual.js'),
                agencyregister:require('./languages.esp/esp.agencyregister.js'),
                agentregister:require('./languages.esp/esp.agentregister.js'),                
                page404:require('./languages.esp/esp.404.js'),
                globalhome:require('./languages.esp/esp.globalhome.js'),
                home:require('./languages.esp/esp.home.js'),
                registerbooking:require('./languages.esp/esp.registerbooking.js'),
                reservhotel:require('./languages.esp/esp.reservhotel.js'),
                trackredeem:require('./languages.esp/esp.trackredeem.js'),
                detailsfaqs:require('./languages.esp/esp.detailsfaqs.js'),
                contactmodal:require('./languages.esp/esp.contactmodal.js'),
                multimediamodal:require('./languages.esp/esp.multimediamodal.js'),
                welcomemodal:require('./languages.esp/esp.welcomemodal.js'),
                webinar:require('./languages.esp/esp.webinar.js')
		
	}

};

export default SetLanguage;
